import { IUser, User } from '@/shared/model/user.model';
import { Address, IAddress } from '@/shared/model/address.model';
import { IRestaurant } from '@/shared/model/restaurant.model';
import { IMessage } from '@/shared/model/message.model';

export interface IMarketer {
  id?: number;
  bankAccountName?: string | null;
  ibanNumber?: string | null;
  cocRegistrationContentType?: string | null;
  cocRegistration?: string | null;
  enabled?: boolean | null;
  completed?: boolean | null;
  approved?: boolean | null;
  newsletter?: boolean | null;
  user?: IUser | null;
  address?: IAddress | null;
  restaurants?: IRestaurant[] | null;
  marketers?: IMarketer[] | null;
  messages?: IMessage[] | null;
  moderator?: IMarketer | null;
}

export class Marketer implements IMarketer {
  constructor(
    public id?: number,
    public bankAccountName?: string | null,
    public ibanNumber?: string | null,
    public cocRegistrationContentType?: string | null,
    public cocRegistration?: string | null,
    public enabled?: boolean | null,
    public completed?: boolean | null,
    public approved?: boolean | null,
    public newsletter?: boolean | null,
    public user?: IUser | null,
    public address?: IAddress | null,
    public restaurants?: IRestaurant[] | null,
    public marketers?: IMarketer[] | null,
    public messages?: IMessage[] | null,
    public moderator?: IMarketer | null
  ) {
    this.address = this.address ?? new Address();
    this.enabled = this.enabled ?? true;
    this.completed = this.completed ?? false;
    this.approved = this.approved ?? false;
    this.newsletter = this.newsletter ?? false;
    this.user = this.user ?? new User();
  }
}
